module.exports = __webpack_public_path__ + "static/media/strata.1b8f8757.jpg";